<template>
  <div id="app">
    <router-view />
    <!-- <el-backtop target="#app" :bottom="20" :right="0"></el-backtop> -->
    <!-- 固定侧边栏 -->
    <fixedToolbar
      :right="0"
      :bottom="140"
      :scroll-container-selector="'.app-main'" 
      @contact="onContact"
      @item-click="onItemClick"
    />
  </div>
</template>

<script>
import fixedToolbar from './components/fixedToolbar.vue';
export default {
  name: 'App',
  components: {
    fixedToolbar
  },
  mounted() {
    
  },
  methods: {
    onContact() {
      // 打开客服窗口
      window.open('https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true', '_blank');
    },
    onItemClick(item) {
      console.log('点击了：', item);
    },
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
